import { Injectable } from '@angular/core';
import {
  Http,
  Request,
  RequestOptions,
  RequestOptionsArgs,
  Response,
  XHRBackend,
} from '@angular/http';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';
// operators
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, of as observableOf, throwError as observableThrowError } from 'rxjs';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class HttpInterceptor extends Http {
  private isRefreshingToken = false;

  constructor(
    private _router: Router,
    backend: XHRBackend,
    options: RequestOptions,
    public http: Http,
    private _toastr: ToastrService,
    private _cookieService: CookieService,
  ) {
    super(backend, options);
  }

  public request(url: Request, options?: RequestOptionsArgs): Observable<Response> {
    const accessToken = localStorage.getItem('access_token');
    if (accessToken) {
      if (url && url.headers) {
        url.headers.set('Authorization', `Bearer ${accessToken}`);
      }
    }
    return super.request(url, options).catch((error: Response) => {
      // Do messaging and error handling here
      try {
        const err = error.json();
        let msg = err.message ? err.message : err.errorMessage ? err.errorMessage : 'Session expired';

        if (error.status === 401) {
          if (msg == 'Session Expired' || msg == 'No auth token') {
            // attempt to extend session if refresh token is still good
            const refresh = localStorage.getItem('refresh_token');
            if (refresh) {
              return this.updateToken({ refresh }).flatMap((result: boolean) => {
                // if got new access token - retry request
                if (result) {
                  return this.request(url, options);
                } else {
                  this.unauthorizedRedirect(msg);
                  return Observable.throw(new Error('Can\'t refresh the token'));
                }
              }).catch(() => {
                this.unauthorizedRedirect(msg);
                return observableOf(null);
              });
            }
          }
          this.unauthorizedRedirect(msg);
          return observableOf(null);
        }
        if (error.status === 403) {
          this._router.navigate(['/']);
          if ([17, 18, 19, 20].includes(err.code)) {
            this._router.navigate(['/cloud-activation']);
            // if ([17, 18].includes(err.code))
            // 	return observableThrowError(error.json());
          }
        }
        if (error.status === 422) {
          return observableThrowError(error.json());
        }

        let details = '';
        if (err.errors && err.errors.length > 0) {
          err.errors.forEach((e) => {
            details += '<br/>' + e.message;
            if ('field' in e) { details += ' \'' + e.field + '\''; }
          });
        }

        // bruteforce detected
        if (err.error && err.error.text && err.error.nextValidRequestDate) {
          const t1 = new Date(err.error.nextValidRequestDate);
          const t2 = new Date();
          const dif = t1.getTime() - t2.getTime();
          msg = err.error.text;
          details = `Next valid request in ${Math.floor(Math.abs(dif / 1000))} seconds`;
        }
        this._toastr.error(details, msg);
      } catch (e) {
        return observableOf(null);
      }
      return observableThrowError(error.json());
    });
  }
  public updateToken(body): Observable<boolean> {
    return this.http.post('../api/v3/auth/refresh', body).map((response: Response) => {
      const data: any = response.json();
      if (typeof data.access_token !== 'undefined') {
        localStorage.setItem('access_token', data.access_token);
        localStorage.setItem('refresh_token', data.refresh_token);
        return true;
      } else {
        return false;
      }
    });
  }
  public jwt() {
    // create authorization header with jwt token
    const accessToken = localStorage.getItem('access_token');
    if (accessToken) {
      return { Authorization: 'Bearer ' + accessToken };
    }
    return {};
  }
  private unauthorizedRedirect(error) {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('current_user');
    this._toastr.error(error);
    setTimeout(() => { this._router.navigate(['/login']); }, 100);
  }
}
